export class Group {
  constructor(group) {
    this.id = group.id,
    this.name = group.name,
    this.description = group.description,
    this.status = group.status
  }
}
